import { z } from "zod";

export const communityFormSchema = z.object({
    communityId: z.string(),
    name: z.string({
        required_error: "name is required",
    }),
    slug: z.string({
        required_error: "URL is required",
    }),
    description: z.string().nullable(),
    bannersBg: z.string().nullish(),
    images: z.object({
        image: z.string().optional(),
        coverImage: z.string().nullish(),
    }),
    socials: z
        .object({
            url: z.string().default(""),
        })
        .nullish()
        .array()
        .optional(),
    mainLinks: z
        .object({
            name: z.string().default(""),
            url: z.string().default(""),
        })
        .nullish()
        .array()
        .optional(),
    otherLinks: z
        .object({
            name: z.string().default(""),
            url: z.string().default(""),
        })
        .nullish()
        .array()
        .optional(),
    categories: z.array(z.string()).nullish().optional(),
});

export type CommunityFormType = z.infer<typeof communityFormSchema>;
